module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_cost-65350f425fa446986f013c10b605e06a.svg";